const productPage = document.querySelector(".single-products");

function formatTime(time, lang) {
	if (lang == "nb-NO") {
		return time.toLocaleTimeString("no-NB", {
			hour: "2-digit",
			minute: "2-digit",
		});
	} else {
		return time.toLocaleTimeString("en-US", {
			timeStyle: "short",
		});
	}
}

function formatDate(date, lang) {
	if (lang == "nb-NO") {
		return date.toLocaleDateString("no-NB", {
			day: "numeric",
			month: "long",
		});
	} else {
		return date.toLocaleDateString("en-US", {
			day: "numeric",
			month: "long",
		});
	}
}

// Connect product details links to accordion
if (productPage) {
	const productDetails = document.querySelector(".product-quick-facts");
	const allLinks = productDetails ? productDetails.querySelectorAll("a") : [];
	const accordions = document.querySelectorAll(".accordion .element-wrapper");

	// put accordions in object where data-id is key
	const accordionObj = {};
	accordions.forEach((accordion) => {
		const id = accordion.getAttribute("data-id");
		accordionObj[id] = accordion;
	});

	//get the url and split out #

	allLinks.forEach((link) => {
		link.addEventListener("click", function (e) {
			// Get href attribute without #
			const href = link.getAttribute("href").split("#")[1];

			// Check if href is in accordionObj
			if (accordionObj[href]) {
				e.preventDefault();
				// Open accoridon with class
				accordionObj[href].classList.add("show-dropdown");

				// Scroll down to accordion
				const offset = accordionObj[href].offsetTop - 100;
				window.scrollTo({
					top: offset,
					behavior: "smooth",
				});
			}
		});
	});
}
